import AppPageBox from "./AppPageBox";

import "./AppPageBox.scss";

export { AppPageBox };
